/* eslint-disable react/prop-types */
/*
Author: Chaitanya
*/

import * as React from 'react';
import {
  createStackNavigator,
  CardStyleInterpolators,
} from '@react-navigation/stack';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { isWeb } from '@global/screens';
import {
  setTitleHeader,
  setDefaultStackOption,
  hasNoAccess,
} from '@global/helpers';

import HamburgerButton from '@components/navbar/HamburgerButton';
import NotificationSettingButton from '@components/navbar/NotificationSettingButton';
import BackButton from '@components/navbar/BackButton';
import ActionButton from '@components/navbar/ActionButton';

import CreditLimitScreen from '@/screens/setting/credit-limit/CreditLimitScreen';
import CreditLimitDetailScreen from '@/screens/setting/credit-limit/CreditLimitDetailScreen';
import CreditLimitFormScreen from '@/screens/setting/credit-limit/CreditLimitFormScreen';

const Stack = createStackNavigator();

// eslint-disable-next-line react/prop-types
const CreditLimitNavigator = ({ navigation }) => {
  const insets = useSafeAreaInsets();

  const goToForm = (props, isAdd = false) => {
    if (
      !isAdd &&
      props &&
      props.route &&
      props.route.params &&
      props.route.params.id
    ) {
      props.navigation.navigate('CreditLimitFormScreen', {
        titleScreen: props.route.params.cost_type,
        name: props.route.params.cost_type,
        id: props.route.params.id,
      });
    } else {
      props.navigation.navigate('CreditLimitFormScreen');
    }
  };

  const hasAccess = !hasNoAccess(['superadmin', 'general']);

  return (
    <Stack.Navigator
      initialRouteName="CreditLimitScreen"
      screenOptions={(props) => ({
        headerLeft: () => <HamburgerButton {...props} />,
        headerRight: () => <NotificationSettingButton {...props} />,
        ...setDefaultStackOption(insets, CardStyleInterpolators),
      })}>
      <Stack.Screen
        name="CreditLimitScreen"
        component={CreditLimitScreen}
        options={(props) => ({
          title: setTitleHeader('Customer Credit Limit'),
          headerRight: () =>
            isWeb ? (
              <NotificationSettingButton {...props} />
            ) : hasAccess ? (
              <ActionButton
                icon={require('@assets/img/icons/plus-white.svg')}
                onCallback={() => goToForm(props, true)}
              />
            ) : (
              false
            ),
        })}
      />
      <Stack.Screen
        name="CreditLimitFormScreen"
        component={CreditLimitFormScreen}
        options={(props) => {
          const route = props.route;
          let title = 'Add Customer Credit Limit';
          let isEdit = false;
          let params = {};
          if (route.params && route.params.titleScreen) {
            title = route.params.titleScreen;
            isEdit = true;
            params = route.params;
          }
          return {
            title: setTitleHeader(title),
            headerLeft: () => (
              <BackButton
                {...props}
                customBack={{
                  screen: isEdit
                    ? 'CreditLimitDetailScreen'
                    : 'CreditLimitScreen',
                  params: params,
                }}
              />
            ),
            headerRight: isWeb
              ? () => <NotificationSettingButton {...props} />
              : false,
          };
        }}
      />
      <Stack.Screen
        name="CreditLimitDetailScreen"
        component={CreditLimitDetailScreen}
        options={(props) => {
          const route = props.route;
          let title = 'Customer Credit Limit Detail';
          if (route.params && route.params.titleScreen) {
            title = route.params.titleScreen;
          }
          return {
            title: setTitleHeader(title),
            headerLeft: () => (
              <BackButton
                {...props}
                customBack={{ screen: 'CreditLimitScreen' }}
              />
            ),
            headerRight: () =>
              isWeb ? (
                <NotificationSettingButton {...props} />
              ) : hasAccess ? (
                <ActionButton
                  icon={require('@assets/img/icons/edit-white.svg')}
                  onCallback={() => goToForm(props)}
                />
              ) : (
                false
              ),
          };
        }}
      />
    </Stack.Navigator>
  );
};

export default CreditLimitNavigator;
